import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Spinner from './components/Spinner'
import DesktopShell from './components/DesktopShell'

// Client pages
import HomePage from './pages/client/HomePage'
import CatalogPage from './pages/client/CatalogPage'
import ProductPage from './pages/client/ProductPage'
import OrdersPage from './pages/client/OrdersPage'
import OrderDetailPage from './pages/client/OrderDetailPage'
import SubmitPaymentPage from './pages/client/SubmitPaymentPage'
import ProfilePage from './pages/client/ProfilePage'
import CustomOrderPage from './pages/client/CustomOrderPage'
import PaymentHistoryPage from './pages/client/PaymentHistoryPage'

// Admin pages
import DashboardPage from './pages/admin/DashboardPage'
import AdminOrdersPage from './pages/admin/AdminOrdersPage'
import AdminOrderDetailPage from './pages/admin/AdminOrderDetailPage'
import PaymentsPage from './pages/admin/PaymentsPage'
import UsersPage from './pages/admin/UsersPage'
import UserDetailPage from './pages/admin/UserDetailPage'
import ProductsPage from './pages/admin/ProductsPage'
import SettingsPage from './pages/admin/SettingsPage'
import RegistryPage from './pages/admin/RegistryPage'
import MorePage from './pages/admin/MorePage'
import BroadcastPage from './pages/admin/BroadcastPage'
import AdminsPage from './pages/admin/AdminsPage'
import AdminDetailPage from './pages/admin/AdminDetailPage'
import PaymentDetailPage from './pages/admin/PaymentDetailPage'

function RootRedirect() {
  const { user, isLoading, isAdmin } = useAuth()
  if (isLoading) return <Spinner className="h-screen" />
  if (!user) return <div className="flex items-center justify-center h-screen text-tg-hint">Требуется авторизация через Telegram</div>
  return <Navigate to={isAdmin ? '/admin' : '/home'} replace />
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <DesktopShell />
        <Routes>
          <Route path="/" element={<RootRedirect />} />

          {/* ── Client routes ── */}
          <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
          <Route path="/catalog" element={<ProtectedRoute><CatalogPage /></ProtectedRoute>} />
          <Route path="/catalog/:id" element={<ProtectedRoute><ProductPage /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
          <Route path="/orders/:id" element={<ProtectedRoute><OrderDetailPage /></ProtectedRoute>} />
          <Route path="/orders/:orderId/pay/:paymentId" element={<ProtectedRoute><SubmitPaymentPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/custom-order" element={<ProtectedRoute><CustomOrderPage /></ProtectedRoute>} />
          <Route path="/payments" element={<ProtectedRoute><PaymentHistoryPage /></ProtectedRoute>} />

          {/* ── Admin routes ── */}
          <Route path="/admin" element={<ProtectedRoute adminOnly><DashboardPage /></ProtectedRoute>} />
          <Route path="/admin/orders" element={<ProtectedRoute adminOnly><AdminOrdersPage /></ProtectedRoute>} />
          <Route path="/admin/orders/:id" element={<ProtectedRoute adminOnly><AdminOrderDetailPage /></ProtectedRoute>} />
          <Route path="/admin/payments" element={<ProtectedRoute adminOnly><PaymentsPage /></ProtectedRoute>} />
          <Route path="/admin/payments/:orderId/:paymentId" element={<ProtectedRoute adminOnly><PaymentDetailPage /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute adminOnly><UsersPage /></ProtectedRoute>} />
          <Route path="/admin/users/:id" element={<ProtectedRoute adminOnly><UserDetailPage /></ProtectedRoute>} />
          <Route path="/admin/products" element={<ProtectedRoute adminOnly><ProductsPage /></ProtectedRoute>} />
          <Route path="/admin/more" element={<ProtectedRoute adminOnly><MorePage /></ProtectedRoute>} />
          <Route path="/admin/broadcast" element={<ProtectedRoute adminOnly><BroadcastPage /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute adminOnly><SettingsPage /></ProtectedRoute>} />
          <Route path="/admin/registry" element={<ProtectedRoute adminOnly><RegistryPage /></ProtectedRoute>} />
          <Route path="/admin/admins" element={<ProtectedRoute adminOnly><AdminsPage /></ProtectedRoute>} />
          <Route path="/admin/admins/:id" element={<ProtectedRoute adminOnly><AdminDetailPage /></ProtectedRoute>} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
